import { render, staticRenderFns } from "./GatewayInfo.vue?vue&type=template&id=2bb96046&"
import script from "./GatewayInfo.vue?vue&type=script&lang=js&"
export * from "./GatewayInfo.vue?vue&type=script&lang=js&"
import style0 from "./GatewayInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VPagination,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bb96046')) {
      api.createRecord('2bb96046', component.options)
    } else {
      api.reload('2bb96046', component.options)
    }
    module.hot.accept("./GatewayInfo.vue?vue&type=template&id=2bb96046&", function () {
      api.rerender('2bb96046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Gateway/GatewayInfo.vue"
export default component.exports